// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".title--18EPeww7 {\n  padding-bottom: 10px;\n}\n\n.player--WYWwiyfG {\n  cursor: pointer;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"title": "title--18EPeww7",
	"player": "player--WYWwiyfG"
};
export default ___CSS_LOADER_EXPORT___;
